/** Canonical 4-step booking wizard funnel (matches CabBookingForm UI). */
export const BOOKING_FUNNEL_STEPS = ["where", "vehicle", "when", "payment"] as const;

export type BookingFunnelStep = (typeof BOOKING_FUNNEL_STEPS)[number];

export const BOOKING_STEP_LABELS: Record<BookingFunnelStep, string> = {
  where: "Where",
  when: "When",
  vehicle: "Vehicle",
  payment: "Review & pay",
};

/** Map legacy 6-step audit names onto the 4-step funnel. */
export function normalizeAuditStepName(
  stepName: string | null | undefined,
): BookingFunnelStep | null {
  if (!stepName) return null;
  switch (stepName) {
    case "where":
    case "when":
    case "vehicle":
    case "payment":
      return stepName;
    case "passengers":
    case "contact":
      return "payment";
    default:
      return null;
  }
}

export function auditStepLabel(stepName: string | null | undefined): string {
  const normalized = normalizeAuditStepName(stepName);
  if (normalized) return BOOKING_STEP_LABELS[normalized];
  return stepName ?? "—";
}

export function auditStepRank(stepName: string | null | undefined): number {
  const normalized = normalizeAuditStepName(stepName);
  if (!normalized) return -1;
  return BOOKING_FUNNEL_STEPS.indexOf(normalized);
}

export function sessionReachedFunnelStep(
  events: { stepName?: string | null; eventType: string }[],
  stepName: BookingFunnelStep,
): boolean {
  const legacyAliases =
    stepName === "payment" ? ["payment", "passengers", "contact"] : [stepName];
  return events.some(
    (event) =>
      event.stepName != null &&
      legacyAliases.includes(event.stepName) &&
      (event.eventType === "step_viewed" ||
        event.eventType === "step_completed" ||
        event.eventType === "next_clicked" ||
        event.eventType === "form_started" ||
        event.eventType === "payment_step_entered"),
  );
}
